import { z } from "zod";

import { scanToCreateConfigurationSchema } from "./scan-to-create-configuration";
import { scanToTriggerConfigurationSchema } from "./scan-to-trigger-configuration";
import { amqpConfigurationSchema } from "./amqp-configuration";

export const importPipelineInputConfigurationSchema = z.object({
	version: z.number(),
	initialVersion: z.number(),
	lastUpdated: z.string(),
	tenantId: z.string(),
	isEnabled: z.boolean().optional(),
	monitoredFolderName: z.string().optional(),
	fileExtension: z.string().optional(),
	defaultDelimiter: z.string().optional(),
	defaultCommentIndicator: z.string().optional(),
	hasHeaders: z.boolean().optional(),
	folderAccessAttempts: z.number().optional(),
	folderAccessPerSecond: z.number().optional(),
	fileAccessAttempts: z.number().optional(),
	fileAccessPerSecond: z.number().optional(),
	cleanFiles: z.boolean().optional(),
	fileDaysToLive: z.number().optional(),
	scanToCreateConfiguration: scanToCreateConfigurationSchema,
	scanToTriggerConfiguration: scanToTriggerConfigurationSchema,
	amqpConfiguration: amqpConfigurationSchema.nullable(),
	headers: z.array(z.string()),
	scope: z.string().nullish(),
});
export type ImportPipelineInputConfiguration = z.infer<typeof importPipelineInputConfigurationSchema>;
